/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_BadgeInputs */

const en_check_in_badge = /** @type {(inputs: Check_In_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13-day rewards`)
};

const es_check_in_badge = /** @type {(inputs: Check_In_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas de 13 dias`)
};

/**
* | output |
* | --- |
* | "13-day rewards" |
*
* @param {Check_In_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_badge = /** @type {((inputs?: Check_In_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_badge(inputs)
	return es_check_in_badge(inputs)
});